export function getUtmParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign"];

  const utmData = {};
  utmKeys.forEach((key) => {
    const value = urlParams.get(key);
    if (value) utmData[key] = value;
  });

  if (Object.keys(utmData).length === 0) {
    const stored = localStorage.getItem("utm_params");
    if (stored) {
      return JSON.parse(stored);
    }
  }

  if (Object.keys(utmData).length > 0) {
    localStorage.setItem("utm_params", JSON.stringify(utmData));
  }

  return utmData;
}

export function redirectToSalesFunnel(path, baseUrl = process.env.SALES_FUNNEL_URL) {
  const utmParams = getUtmParams();
  const queryString = new URLSearchParams(utmParams).toString();

  const redirectUrl = queryString
    ? `${baseUrl}?${queryString}`
    : `${baseUrl}`;

  window.location.href = redirectUrl;
}